import Tabs from './components/tabs'

$(document).ready(function () {
  if($('.presse').length > 0) {
    new Tabs();
  }
});